import '../../../styles/supervise.scss';
import './index.scss';
import React from 'react';
import RealTimeSupervise from '@/busi/saas/supervise/instructionalSupervision/realTimeSupervise';

function MySupervisor() {
  return (
    <div className="my-supervisor">
      <RealTimeSupervise type="mySupervisor" />
    </div>
  );
}

export default MySupervisor;
